import type { VFileBrowserContextValue } from '../type';
import FileBrowserContentDragboxContext from './fileBrowserContentDragboxContext';
import FileBrowserContext from './fileBrowserContext';
import FileBrowserScrollContext from './fileBrowserScrollContext';

export const useFileBrowserContext = () =>
  FileBrowserContext.hook<VFileBrowserContextValue>();

export const useFileBrowserContentDragboxContext =
  FileBrowserContentDragboxContext.hook;

export const useFileBrowserScrollContext = FileBrowserScrollContext.hook;
